export const STAMPINGS_TAG_EVENTS = {
  SUCCESS_STAMPING: 'StampingSuccess',
  FAILED_STAMPING: 'StampingFailed',
  SEND_EMAIL_PAYROLL_RECEIPT: 'PayStubSent',
  SEND_HR_PAYROLL_RECEIPT: 'PayStubSentWorky',
};
